import type { Org } from '@/types';

/**
 * Utility to normalize a path by removing trailing slashes.
 */
export function normalizePath(path: string): string {
  return path.replace(/\/+$/, '');
}

/**
 * Utility function for robust route matching.
 * Returns true if `path` is a child route of `base`.
 */
export function isChildRoute(base: string, path: string): boolean {
  const normalizedBase = normalizePath(base);
  const normalizedPath = normalizePath(path);

  if (normalizedPath === normalizedBase) {
    // Exact match is not considered a child route
    return false;
  }

  return normalizedPath.startsWith(`${normalizedBase}/`);
}

/**
 * Filters an org list by name or ID against a search query.
 * Returns all orgs when query is empty.
 */
export function filterOrgs(orgs: Org[], query: string): Org[] {
  const q = query.trim().toLowerCase();

  if (!q) return orgs;

  return orgs.filter(o => o.name.toLowerCase().includes(q) || String(o.id).toLowerCase().includes(q));
}
